import { z } from "zod";

export interface OkResponse {
  status: string;
  message: string;
}

export const ExpectedOkResponse = {
  status: "OK",
  message: "Request processed successfully",
};

export const OkResponseSchema = z.object({
  status: z.string(),
  message: z.string(),
});
